// ABOUTME: Nav-only tab bar component with string-based tab IDs
// ABOUTME: Replaces duplicated inline tab patterns across side pages

import { cn } from "@shared/lib/utils"

interface CTabBarProps<T extends string> {
  tabs: { id: T; label: React.ReactNode }[]
  activeTab: T
  onChange: (tab: T) => void
  className?: string
}

export function CTabBar<T extends string>({ tabs, activeTab, onChange, className }: CTabBarProps<T>) {
  return (
    <div className={cn("flex border-b border-gray-300 mb-3", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={cn(
            "px-4 py-2 text-sm font-medium transition-colors cursor-pointer",
            activeTab === tab.id ? "border-b-2 border-blue-500 text-blue-600" : "text-gray-500 hover:text-gray-700",
          )}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
